import { render, staticRenderFns } from "./FlagLang.vue?vue&type=template&id=09bc4268&"
import script from "./FlagLang.vue?vue&type=script&lang=js&"
export * from "./FlagLang.vue?vue&type=script&lang=js&"
import style0 from "./FlagLang.vue?vue&type=style&index=0&id=09bc4268&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports